import styled, { css } from "styled-components";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

const Table = ({
  columns,
  isTableDataLoading,
  data,
  onRowClick,
  columnFontColor,
  columnFontSize,
  columnFontWeight,
  headerHidden,
  fixedLayout,
}) => {
  return (
    <StyledTable fixedLayout={fixedLayout}>
      {!headerHidden && (
        <TableHeader
          columns={columns}
          columnFontColor={columnFontColor}
          columnFontSize={columnFontSize}
          columnFontWeight={columnFontWeight}
        ></TableHeader>
      )}
      <TableBody
        isTableDataLoading={isTableDataLoading}
        columns={columns}
        data={data}
        onRowClick={onRowClick}
      ></TableBody>
    </StyledTable>
  );
};

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  ${(props) =>
    props.fixedLayout &&
    css`
      table-layout: fixed;
      overflow-x:scroll;
    `}
`;

export default Table;
